const NavigationMode = {
	Auto: "Auto",
	Vertical: "Vertical",
	Horizontal: "Horizontal",
};
export default NavigationMode;
